/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_TitleInputs */

const en_directory_submit_enrich_title = /** @type {(inputs: Directory_Submit_Enrich_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Autofill — deep enrich pipeline`)
};

const zh_directory_submit_enrich_title = /** @type {(inputs: Directory_Submit_Enrich_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 自动填充 — 深度增强流水线`)
};

/**
* | output |
* | --- |
* | "AI Autofill — deep enrich pipeline" |
*
* @param {Directory_Submit_Enrich_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_title = /** @type {((inputs?: Directory_Submit_Enrich_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_title(inputs)
	return zh_directory_submit_enrich_title(inputs)
});
export { directory_submit_enrich_title as "directory.submit.enrich.title" }